import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type HopTimusDockStatus = 'idle' | 'loading' | 'ready' | 'failed'

interface HopTimusState {
  isLoading: boolean
  dockAvailable: boolean
  dockStatus: HopTimusDockStatus
  dockUrl: string | null
}

const initialState: HopTimusState = {
  isLoading: false,
  dockAvailable: false,
  dockStatus: 'idle',
  dockUrl: null,
}

const activationRequestedHandler = (state: HopTimusState) => {
  state.isLoading = true
}

const activationSettledHandler = (state: HopTimusState) => {
  state.isLoading = false
}

const dockAvailabilityChangedHandler = (state: HopTimusState, action: PayloadAction<boolean>) => {
  state.dockAvailable = action.payload
  state.dockStatus = 'idle'
  state.dockUrl = null
}

const dockActivationRequestedHandler = (state: HopTimusState) => {
  state.dockStatus = 'loading'
}

const dockActivationSucceededHandler = (state: HopTimusState, action: PayloadAction<string>) => {
  state.dockStatus = 'ready'
  state.dockUrl = action.payload
}

const dockActivationFailedHandler = (state: HopTimusState) => {
  state.dockStatus = 'failed'
  state.dockUrl = null
}

const hopTimusSlice = createSlice({
  name: 'hopTimus',
  initialState,
  reducers: {
    activationRequested: activationRequestedHandler,
    activationSettled: activationSettledHandler,
    dockAvailabilityChanged: dockAvailabilityChangedHandler,
    dockActivationRequested: dockActivationRequestedHandler,
    dockActivationSucceeded: dockActivationSucceededHandler,
    dockActivationFailed: dockActivationFailedHandler,
  },
})

export const {
  activationRequested,
  activationSettled,
  dockAvailabilityChanged,
  dockActivationRequested,
  dockActivationSucceeded,
  dockActivationFailed,
} = hopTimusSlice.actions

export default hopTimusSlice.reducer
